<template>
    <v-dialog v-if="appData.general_announcement" max-width="450" class="announcement-dialog" v-model="show" overlay-color="#000" overlay-opacity="0.45">
        <v-card>
            <v-card-title class="d-flex justify-space-between">
                <div class="strong-text--text d-flex align-center">
                    <v-icon color="primary" size="25" class="me-2">mdi-bullhorn-outline</v-icon>
                    <span>Announcement</span>
                </div>
                <div>
                    <v-btn icon @click="show=false;">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </v-card-title>
            <v-card-text>
                <div class="text--text" style="whitespace: pre-line; font-size: 15px; line-height: 1.8;" v-html="urlify(escapeHtmlText(appData.general_announcement))"></div>    
            </v-card-text>
        </v-card>        
    </v-dialog>    
</template>
<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';

export default {
    props: {
        value: {},
    },
    data(){
        return {
            show: false,
        }    
    },
    components: {},
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,

        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system'};
            return linkifyHtml(text, options);
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
    },
    watch: {
        show(show){
            if (!show){
                this.$emit('input', false); // close
                window.setTimeout(()=>{
                    this.$store.commit('SET_ANNOUNCEMENT_DISMISSED', true);
                }, 500);
            }
        },
        value(show){
            this.show = show;
        },
        
    },
    mounted(){
        this.show = this.value;
    }
}
</script>
<style lang="scss" scoped>

</style>
